//@flow
import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import PaginatedTable, { StickyPositionEnum } from './PaginatedTable';
import TableControls from 'common/components/core/table/TableControls';

import theme from './PaginatedTableWithControls.scss';

export const DEFAULT_PAGE_SIZE = 15;

type Props = {
    data: Array<any>,
    totalPages: ?number,
    theme: Object,
    columns: Array<Object>,
    enableFiltering: boolean,
    hasCheckbox?: boolean,
    className?: string,
    onDelete: () => void,
    disableDeleteButton?: boolean,
    deleteButtonTooltip?: ?string,
    getTrProps?: (Object, Object, Object, Object) => Object,
    onTableStateChange: ({
        pageSize: number,
        page: number,
        sorted: Array<Object>,
        filtered: Object
    }) => void
};

type State = {
    pageSize: number,
    sorted: Array<Object>,
    selectedPageIndex: number
};
const paginatedTableWithControlsFactory = ({
    PaginatedTableComponent = PaginatedTable,
    TableControlsComponent = TableControls
}) => {
    class PaginatedTableWithControls extends PureComponent<Props, State> {
        getColumns() {
            const {
                columns,
                theme,
                onDelete,
                disableDeleteButton,
                deleteButtonTooltip
            } = this.props;
            return [
                ...columns,
                {
                    headerText: '',
                    id: 'controls',
                    filterable: false,
                    sortable: false,
                    width: 30,
                    Cell: props => {
                        const { original, tdProps } = props;
                        return (
                            <TableControlsComponent
                                theme={theme}
                                row={original}
                                tdProps={tdProps}
                                onDelete={onDelete}
                                disableDeleteButton={disableDeleteButton}
                                deleteButtonTooltip={deleteButtonTooltip}
                            />
                        );
                    },
                    fixed: StickyPositionEnum.Right
                }
            ];
        }

        render() {
            return (
                <PaginatedTableComponent
                    {...this.props}
                    columns={this.getColumns()}
                />
            );
        }
    }
    return themr(
        'PaginatedTableWithControls',
        theme
    )(PaginatedTableWithControls);
};

const PaginatedTableWithControls = paginatedTableWithControlsFactory({});
export { paginatedTableWithControlsFactory };
export default PaginatedTableWithControls;
